// lib/utils/weatherAnimations.ts
export function mapWeatherCodeToAnimation(code: number): string {
  switch (code) {
    case 0: // Чистое небо
      return '/animations/sunny.json';
    case 1: // В основном ясно
      return '/animations/sun-cloud.json';
    case 2: // Переменная облачность
    case 3: // Пасмурно
      return '/animations/cloudy2.json';
    case 45: // Туман
    case 48: // Изморозь
      return '/animations/foggy.json';
    case 51: // Морось: слабая
    case 53: // Морось: умеренная
    case 55: // Морось: сильная
      return '/animations/drizzle.json';
    case 61: // Дождь: слабый
      return '/animations/rain-light1.json';
    case 63: // Дождь: умеренный
    case 65: // Дождь: сильный
      return '/animations/rainy.json';
    case 66: // Ледяной дождь: слабый
    case 67: // Ледяной дождь: сильный
      return '/animations/freezing-rain.json';
    case 71: // Снегопад: слабый
    case 73: // Снегопад: умеренный
    case 75: // Снегопад: сильный
    case 77: // Снежные зерна
      return '/animations/snowy2.json';
    case 80: // Ливни: слабые
    case 81: // Ливни: умеренные
    case 82: // Ливни: сильные
      return '/animations/rainy.json';
    case 85: // Снежные ливни: слабые
    case 86: // Снежные ливни: сильные
      return '/animations/snowy.json';
    case 95: // Гроза: слабая или умеренная
    case 96: // Гроза с градом: слабая
    case 99: // Гроза с градом: сильная
      return '/animations/thunderstorm.json';
    default:
      return '/animations/sunny.json'; // Запасной вариант
  }
}
